import React, {Component} from 'react';

import PieChart from './PieChart.js';

import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';


const pieData = [
    {
        "id": "year_1",
        "label": "1년차",
        "value": 3371
    },
    {
        "id": "year_2",
        "label": "2년차",
        "value": 2479
    },
    {
        "id": "year_3",
        "label": "3년차",
        "value": 1745
    },
    {
        "id": "year_4",
        "label": "4년차",
        "value": 347
    }
];

class ContractYearPie extends Component {

    constructor(props) {
        super(props);
        var year = this.props.year ? this.props.year : new Date().getFullYear();
        this.state = {
            isLoaded : false,
            year : year,
            tomonote : this.props.tomonote,
            tomonote : this.props.tomonote
        }
    }

    componentDidMount(){    
        this.getData(this.state.year);
    }

    componentWillReceiveProps = (nextProps) => {

        if(this.state.year != nextProps.year || this.state.tomonote != nextProps.tomonote || this.state.tomobooks != nextProps.tomobooks) {
            this.setState({
                isLoaded :false, 
                tomonote : nextProps.tomonote,
                tomobooks : nextProps.tomobooks
            }, () => this.getData(nextProps.year));
        }
    }



    getData = (year) => {
        if(!year) year = new Date().getFullYear();
        axios({
          method: "get",
          url: Constant.API_DOMAIN + "/api/petit/contractYear/" + year + "/0"
        })
          .then(result => {
            if(result.data.code === 200) {
                var _1year = 0;
                var _2year = 0;
                var _3year = 0;
                var _4year = 0;
                var _5year_more = 0;
                if(this.state.tomonote) {
                    _1year += result.data.data.tomonote[0]._1year;
                    _2year += result.data.data.tomonote[0]._2year;
                    _3year += result.data.data.tomonote[0]._3year;
                    _4year += result.data.data.tomonote[0]._4year;
                    _5year_more += result.data.data.tomonote[0]._5year_more;
                }

                if(this.state.tomobooks) {
                    _1year += result.data.data.tomobooks[0]._1year;
                    _2year += result.data.data.tomobooks[0]._2year;
                    _3year += result.data.data.tomobooks[0]._3year;
                    _4year += result.data.data.tomobooks[0]._4year;
                    _5year_more += result.data.data.tomobooks[0]._5year_more;
                }

                var contractYearList = [];
                contractYearList.push({"name" : "1년차", "value" : _1year});
                contractYearList.push({"name" : "2년차", "value" : _2year});
                contractYearList.push({"name" : "3년차", "value" : _3year});
                contractYearList.push({"name" : "4년차", "value" : _4year});
                contractYearList.push({"name" : "5년 이상", "value" : _5year_more});
                
                this.setState({
                    isLoaded : true,
                    data : contractYearList,
                    year : year
                })
            } 
            
          })
          .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
    }




	render() {
            if (this.state.isLoaded && this.state.data.length > 0) {
                return (
                    <div className="card border-top border-3 border-info"  >
                        <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                            <h5 className="card-header-title">연차</h5>
                        </div>
                        <div className="card-body" style={{height: this.props.height+ "px"}}>
                            <PieChart data={this.state.data} height={this.props.height}/>
                        </div>
                    </div>
                )
            } else if(this.state.isLoaded && this.state.data.length == 0) {
                return (
                    <div className="card border-top border-3 border-top-primary">
                        <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                            <h5 className="card-header-title">연차</h5>
                        </div>
                        <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"100px"}}>
                            No Data
                        </div>
                    </div>
                )
            } else {
                return(
                    <div className="card border-top border-3 border-top-primary">
                        <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                            <h5 className="card-header-title">연차</h5>
                        </div>
                        <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"100px"}}>
                            <span className="dashboard-spinner spinner-xxl"></span>
                        </div>
                    </div>
                )
            }

	}

}


export default ContractYearPie;